const INPUT = "w-full border-0 border-b-2 border-[#E7E5DF] bg-transparent px-0 pb-3 pt-1 font-display text-2xl text-[#2C2C2A] outline-none transition-colors placeholder:text-[#8A887F]/70 focus:border-[#0F6E56] focus-visible:outline-none sm:text-[28px] aria-[invalid=true]:border-[#B42318]";

const One = ({ k, label, ph, ac, value, onChange, invalid, inputRef, autoFocusAttr }) => (
  <div className="min-w-0">
    <label htmlFor={`lead-${k}`} className="block font-mono-data text-[12px] uppercase tracking-[0.14em] text-[#6B6961]">
      {label}<span className="text-[#0F6E56]">*</span>
    </label>
    <input
      ref={inputRef}
      id={`lead-${k}`}
      type="text"
      autoComplete={ac}
      value={value}
      placeholder={ph}
      onChange={(e) => onChange(k, e.target.value)}
      aria-invalid={invalid}
      aria-required="true"
      aria-describedby={invalid ? "lead-nome-err" : undefined}
      className={`${INPUT} mt-2`}
      data-testid={`lead-input-${k}`}
      {...(autoFocusAttr ? { "data-lead-autofocus": true } : {})}
    />
  </div>
);

export const FullName = ({ data, onChange, errField, inputRef, autoFocusAttr }) => (
  <div className="grid gap-7 sm:grid-cols-2 sm:gap-6" data-testid="lead-fullname">
    <One k="nome" label="Nome" ph="Mario" ac="given-name" value={data.nome} onChange={onChange} invalid={errField === "nome"} inputRef={inputRef} autoFocusAttr={autoFocusAttr} />
    <One k="cognome" label="Cognome" ph="Rossi" ac="family-name" value={data.cognome} onChange={onChange} invalid={errField === "cognome"} />
  </div>
);
